import styled from 'styled-components';
import { Input } from 'antd';

export const SectionCareerHero = styled.div`
  padding: 0;
  position: relative;
  background: ${props =>
    props.backgroundImg != null ? 'url(' + props.backgroundImg + ')' : props.backgroundColor};
  background-size: cover;
  max-height: 600px;
  background-position: center;

  @media (max-width: 768px) {
    background-position: right;
    padding-top: 100px;
  }

  .ant-input-affix-wrapper {
    position: relative;

    .ant-input-prefix {
      position: absolute;
      right: 10px;
      top: 20px;
      z-index: 9;
    }
  }

  .ant-input-affix-wrapper.filled {
    .ant-input-prefix {
      display: none;
    }
  }

  .careers-hero--search-container {
    display: flex;
    margin-top: 40px;
  }

  .section-career-hero--copy {
    a {
      background: var(--blue-5);

      &:hover {
        background: var(--blue-6);
      }
    }
  }

  .section-career-hero--container {
    position: relative;
    z-index: 2;
    padding: 260px 28px;
    text-align: left;

    @media (max-width: 768px) {
      text-align: center;
    }

    .section-career-hero--copy {
      max-width: 1296px;
      margin: 0 auto;
    }

    .section-career-hero--title {
      font-weight: 900;
      font-size: 61px;
      line-height: 110%;
      letter-spacing: -0.05em;
      color: ${props => props.titleColor};
      max-width: 400px;
    }

    .section-career-hero--button {
      font-weight: bold;
      font-size: 20px;
      line-height: 110%;
      padding: 20px 24px;
      margin-left: 20px;
    }
  }

  @media (max-width: 768px) {
    padding: 0;
    .section-career-hero--container {
      padding: 0;

      .section-career-hero--title {
        font-size: 32px;
        letter-spacing: -0.03em;
        max-width: 590px;
        margin: 0 auto 15px auto;
        padding-bottom: 20px;
      }
      .section-career-hero--button {
        font-size: 18px;
        padding: 18px 24px;
        margin-top: 24px;
      }
    }
    .section-career-hero--copy {
      text-align: center;
      margin-top: 50px 0;
    }
  }

  @media (max-width: 576px) {
    .section-career-hero--container {
      padding: 100px 20px 102px;

      .section-career-hero--button {
        width: 100%;
        margin-top: 24px;
      }
    }
  }
`;

export const CareerHeroMobileContainer = styled.div`
  @media (max-width: 768px) {
    .careers-hero--search-container {
      display: flex;
      margin-top: 40px;
      justify-content: center;

      button {
        margin: 0 0 0 20px;
      }
    }
    .section-career-hero--button {
      margin-top: 10px;
    }
    .section-career-hero--container {
      margin: 80px 0 0 0;
      padding: 0;
      height: 200px;
    }
    .section-career-hero--copy {
      background: ${({ background }) => `url(${background})`};
      text-align: center;
      padding: 50px 0;
      background-size: cover;
      background-position: center;

      a {
        background: var(--blue-5);

        &:hover {
          background: var(--blue-6);
        }
      }
    }
  }
`;

export const SectionCareerAwards = styled.div`
  padding: 0 20px;

  .section-career-awards--container {
    padding: 30px 0 32px;
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;

    .section-career-awards--content {
      margin-top: 35px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      .section-career-awards--item {
        flex: 0 0 16%;
        padding: 0;
        margin: 48px 20px;
        border: 2px solid var(--blue-5);
        border-radius: 50%;
        height: 192px;
        width: 192px;

        .section-career-awards--image-wrapper {
          margin: 0 auto;
          width: 100%;
          height: 188px;
          width: 188px;
          vertical-align: middle;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            padding: 5px;
          }
        }
      }
    }
  }

  @media (max-width: 991px) {
  }

  @media (max-width: 768px) {
    .section-career-awards--container {
      padding: 30px 0 33px;

      .section-career-awards--title {
        font-size: 29px;
        margin-bottom: 25px;
        line-height: 110%;
        letter-spacing: -0.03em;
      }

      .section-career-awards--content {
        margin-top: 17px;

        .section-career-awards--item {
          padding: 0;
          margin: 15px 5px;
          flex: 0 0 25%;
        }
      }
    }
  }

  @media (max-width: 576px) {
    .section-career-awards--container {
      padding: 20px 0 33px;

      .section-career-awards--content {
        margin-top: 17px;

        .section-career-awards--item {
          flex: 0 0 25%;
          margin: 15px;
          padding: 0px;
          height: 110px;
          width: 110px;

          .section-career-awards--image-wrapper {
            height: 105px;
            width: 105px;
            margin: 0 auto;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
`;

export const CareersVisionSection = styled.div`
  padding: 0 20px;
  margin-top: 60px;

  .careers--underlined-heading {
    text-transform: uppercase;
    width: fit-content;
    text-align: left;
    max-width: 1200px;
    margin: 0 auto;
  }

  .careers--vision-content-wrapper {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0;
    padding: 30px 0 32px;

    .careers--vision-content-container {
      display: flex;
      align-items: flex-end;

      .careers--vision-copy-container {
        width: 50%;

        .careers--vision-copy-container-bg {
          padding: 75px;
          background-color: var(--blue-primary);
          width: 120%;
          z-index: 1;

          .careers--vision-copy-wrap {
            max-width: 70%;

            p {
              font-weight: normal;
            }
          }
        }
      }
    }

    img {
      position: relative;
      width: 50%;
      z-index: 2;
    }
    .careers--vision-mobile-img {
      display: none;
    }
  }

  @media (max-width: 576px) {
    .careers--underlined-heading {
      margin: 0 auto;
    }

    .careers--vision-content-wrapper {
      .careers--vision-content-container {
        margin-top: 30px;
        flex-direction: column;
        max-height: 400px;

        .careers--vision-copy-container {
          width: 100% !important;

          .careers--vision-copy-container-bg {
            padding: 60px 30px !important;
            width: 100% !important;

            .careers--vision-copy-wrap {
              max-width: 100% !important;
            }
          }
        }
      }
      img {
        top: -67px;
        width: 100%;
      }
      .careers--vision-mobile-img {
        display: block;
      }
      .careers--vision-desktop-img {
        display: none;
      }
    }
  }
`;

export const CareersValuesCarouselSection = styled.div`
  width: 100%;
  margin-top: 120px;
  .careers--underlined-heading {
    text-transform: uppercase;
    width: fit-content;
    margin: 60px auto;
    text-align: center;
  }

  .careers--values-carousel-container {
    width: 100%;
    .slick-prev {
      top: 80%;
      right: 10%;
      left: auto;
      z-index: 10000;
    }
    img.slick-arrow.slick-prev,
    img.slick-arrow.slick-next {
      width: 30px;
      height: 30px;
    }
    .slick-next {
      top: 80%;
      right: 7%;
    }
    .slick-dots {
      bottom: 20px;
      background: #ffffff;
      border: 1px solid white;
      border-radius: 3px;
      width: fit-content;
      display: flex !important;
      justify-content: center;
      position: relative;
      bottom: 35px;
      margin: 0 auto;
      li button:before {
        color: var(--secondary-color);
      }
      li.slick-active button:before {
        color: var(--input-selected-color);
      }
    }
    .careers--value-item-container {
      width: 100%;
      display: flex !important;
      flex-direction: row;
      .careers--values-item-wrap {
        display: flex;
        flex-direction: row;
        width: 50%;
        background-color: var(--blue-primary);
        .careers--value-image {
          background-size: cover;
          background-repeat: no-repeat;
          width: 100%;
          height: 500px;
        }
        .careers--values-copy-container {
          padding: 60px;
          margin: auto 0;

          .careers--values-kicker {
            text-transform: uppercase;
            font-size: 16px;
            color: #fff;
          }

          .careers--values-heading {
            color: #fff;
          }

          .careers--values-body {
            color: #fff;
            margin-block-start: 0px;
            padding-inline-start: 15px;
            list-style: square;

            li {
              font-family: var(--font-family);
              font-size: 16px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
    margin-top: 30px;
    .careers--values-carousel-container {
      .slick-prev {
        top: 92%;
        right: 15%;
      }
      .slick-next {
        top: 92%;
        right: 7%;
      }
      .slick-dots {
        bottom: 43px;
      }
    }
    .careers--value-item-container {
      flex-direction: column !important;
      .careers--values-item-wrap {
        width: 100% !important;
        .careers--value-image {
          height: 300px !important;
        }
        .careers--values-copy-container {
          min-height: 373px;
        }
      }
    }
  }
`;

export const CareersLifeHoverSection = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px;
  margin-top: 60px;
  display: flex;
  flex-direction: row;

  .tabbed-content {
    display: none;
  }

  .careers--life-hover-container {
    width: 30%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .careers--underlined-heading {
    text-transform: uppercase;
    width: fit-content;
    text-align: center;
    margin-bottom: 30px;
  }

  .careers--life-default-image {
    width: 100%;
    img {
      width: 120%;
      -webkit-mask-image: linear-gradient(to left, transparent 1%, black 33%);
      mask-image: linear-gradient(to left, transparent 1%, black 33%);
      z-index: 2;
    }
  }

  .careers--life-hover-item {
    width: 100%;
    max-width: 75%;
    padding: 30px 0;
    cursor: pointer;
    ${({ active }) =>
      active &&
      `
      border-bottom: 2px solid black;
      opacity: 1;
    `}
    p {
      margin: 0;
    }
  }
  .careers--life-hover-item:hover {
    background: #fff;
    box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08);
  }

  #careers--life-hover-content {
    width: 70%;
    display: flex;
    flex-direction: row;

    .careers--life-quote-content {
      position: absolute;
      width: 100%;
      background: rgba(255, 255, 255, 0.95);
    }

    .careers--life-hover-image {
      background-size: cover;
      background-position: center top;
      width: 363px;
      min-width: 304px;
      height: 513px;
      border-left: 10px solid #00a9f7;
    }
    .careers--life-copy-container {
      padding: 60px 30px;
      width: 100%;

      .careers--life-hover-quote {
        max-width: 380px;
        z-index: 92725;
        padding-left: 40px;
        position: relative;
      }
      .careers--life-quotee-name,
      .careers--life-quotee-role {
        font-weight: bold;
        font-size: 20px;
        padding-left: 40px;
        color: #000000;
        margin-bottom: 5px;
      }
    }
    .careers--life-copy-container:before {
      content: '"';
      font-size: 120px;
      line-height: 0;
      color: #d3f1ff;
      z-index: 10;
      font-family: Courier;
      position: absolute;
      padding-top: 25px;
    }
  }

  @media (max-width: 576px) {
    display: block;
    padding: 30px;

    .careers--underlined-heading {
      text-align: center;
      margin: 0 auto 60px;
    }

    .careers--life-hover-container {
      display: block;
      width: 95%;
      align-content: center;

      .careers--life-hover-item {
        display: none;
      }
    }
    #careers--life-hover-content {
      width: 100%;
      flex-direction: column;
      overflow: hidden;

      .careers--life-default-image img {
        min-height: 400px;
        width: auto;
      }

      .careers--life-hover-image {
        height: 300px !important;
        width: 85vw;
        min-width: unset;
      }
      .careers--life-copy-container {
        padding: 60px 0px;

        .careers--life-quotee-name,
        .careers--life-quotee-role {
          font-size: 16px !important;
        }
      }
    }
    .careers--life-quote-content {
      flex-direction: column;
    }
  }
`;

export const CareersPerksSection = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px;
  display: flex;
  flex-direction: column;

  .careers--underlined-heading {
    text-transform: uppercase;
    width: fit-content;
    text-align: center;
    margin: 0 auto;
    margin-bottom: 30px;
  }

  .careers--perks-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: flex-start;

    .careers--perk {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 32%;

      img {
        width: 100px;
        height: 100px;
        margin: 20px;
      }

      .careers--perk-body {
        font-size: 18px;
      }
    }
  }

  @media (max-width: 576px) {
    .careers--perks-row {
      flex-direction: column;
      align-items: center;
    }

    .careers--perk {
      width: 95% !important;
    }
  }
`;

export const CareersCultureSection = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px;
  display: flex;
  flex-direction: column;

  .careers--underlined-heading {
    text-transform: uppercase;
    width: fit-content;
    text-align: center;
    margin: 0 auto;
    margin-bottom: 60px;
  }

  .careers--culture-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .careers--culture-item {
      height: 410px;
      width: 48%;
      display: flex;
      flex-direction: column;

      .careers--culture-overlay {
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100%;
        width: 100%;
        transition: 0.3s ease-in-out;
        background-color: rgba(25, 55, 79, 0);
        padding: 20px;
      }

      .careers--culture-heading {
        color: #ffffff;
        margin-bottom: 0px;
      }

      .careers--culture-list {
        margin-top: 20px;
        color: #ffffff;

        li {
          font-family: var(--font-family);
          font-size: 20px;
          line-height: 150%;
        }
      }
    }
    .careers--culture-item:hover .careers--culture-overlay {
      background-color: rgba(25, 55, 79, 0.8);
    }
  }
  .careers--culture--button {
    width: 100%;
    max-width: 360px;
    margin: 60px auto;
  }

  @media (max-width: 576px) {
    padding: 30px 20px;

    .careers--culture-row {
      flex-direction: column !important;

      .careers--culture-item {
        width: 100% !important;
        height: 100%;
        background-color: rgba(25, 55, 79, 0.8);
      }
      .careers--culture-overlay {
        background-color: rgba(25, 55, 79, 0.8) !important;
      }
    }
  }
`;

export const CareersLocationsSection = styled.div`
  background: transparent;

  .section-career-core--wrapper {
    background: ${props =>
      'linear-gradient(180deg, ' + props.backgroundColor + ' 80%, transparent 80%)'};
    padding: 80px 28px 20px;
  }

  .careers--underlined-heading {
    text-transform: uppercase;
    width: fit-content;
    text-align: center;
    margin: 0 auto;
    margin-bottom: 30px;
  }

  .section-career-core--container {
    max-width: 1240px;
    margin: 0 auto;

    .section-career-core--title {
      font-weight: 900;
      font-size: 49px;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.04em;
      text-align: center;
      color: ${props => props.titleColor};
    }

    .section-career-core--content {
      display: flex;
      margin-top: 64px;

      .section-career-core--item {
        height: 550px;
        background-repeat: no-repeat;
        background-size: cover;
        width: 100%;
        position: relative;
        background-position: center;

        .section-career-core--item-text-container {
          position: absolute;
          bottom: 0;
          padding: 20px;
          display: flex;
          flex-direction: column;

          .section-career-core--item-title {
            margin-bottom: 10px;
          }

          .section-career-core--item-description {
            margin: 0;
          }
        }

        .section-career-core--item-background {
          width: 100%;
          height: 100%;
          background: #0b1a21;
          opacity: 0.2;
          position: absolute;
        }

        .section-career-core--item-background1 {
          width: 100%;
          height: 100%;
          background: linear-gradient(360deg, rgba(0, 0, 0, 0.7) 25.77%, rgba(0, 0, 0, 0) 55.64%);
          position: absolute;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .section-career-core--wrapper {
      padding: 48px 28px;
    }

    .section-career-core--container {
      .section-career-core--title {
        font-size: 29px;
        margin-bottom: 25px;
      }

      .section-career-core--content {
        margin-top: 47px;

        .section-career-core--item {
          height: 374px;

          .section-career-core--item-text-container {
            padding: 24px;

            .section-career-core--item-title {
              font-size: 26px;
              letter-spacing: -0.02em;
            }
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
    .section-career-core--wrapper {
      padding: 48px 20px;
    }

    .section-career-core--container {
      .section-career-core--content {
        flex-direction: column;
        margin-top: 28px;

        .section-career-core--item {
          height: 320px;

          .section-career-core--item-text-container {
            padding: 24px;
          }
        }
      }
    }
  }
`;

export const CareersTimelineSection = styled.div`
  background: ${props => props.background};

  .careers--underlined-heading {
    text-transform: uppercase;
    width: fit-content;
    text-align: center;
    margin: 0 auto;
    margin-bottom: 30px;
  }

  .section-company-milestones--container {
    padding: 96px 28px 144px;
    margin: 0 auto;

    .section-company-milestones--title {
      font-weight: 900;
      font-size: 49px;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.04em;
      color: var(--normal-title-color);
    }

    .toggle--switch input {
      cursor: pointer;
      height: 100%;
      opacity: 0;
      position: absolute;
      width: 100%;
      z-index: 100;
    }

    .toggle--switch {
      height: 100px;
      margin: 25px auto;
      padding: 10px;
      position: relative;
      width: 500px;
    }

    .toggle--switch label {
      background: #eeeeee;
      border-radius: 50px;
      color: var(--blue-primary);
      display: block;
      font-family: Sofia Pro;
      font-size: 18px;
      font-weight: 500;
      height: 100%;
      position: relative;
      transition: all 0.5s ease;
      width: 100%;
    }

    .toggle--switch label .toggle--toggle {
      border-radius: 2px;
      display: block;
      height: calc(100% - 10px);
      left: 6px;
      position: absolute;
      top: 6px;
      transition: all 0.5s ease;
      width: 50%;
      z-index: 3;
    }

    .toggle--switch label .toggle--toggle:before {
      align-items: center;
      background: #ffffff;
      border-radius: 50px;
      bottom: 0;
      box-shadow: 0 3px 6px 1px rgba(160, 161, 188, 0.35);
      content: '';
      display: flex;
      height: 100%;
      justify-content: center;
      left: 0;
      margin: auto;
      position: absolute;
      right: 0;
      top: -2px;
      transition: all 0.5s ease;
      width: auto;
    }

    .toggle--switch input:checked ~ label .toggle--toggle {
      left: calc(50% + -6px);
    }

    .toggle--title {
      text-align: center;
      z-index: 9;
      margin: 0;
    }

    .toggle--title-container {
      align-items: center;
      display: flex;
      height: 100%;
      justify-content: center;
      width: 50%;
    }

    .toggle--titles {
      height: 100%;
      display: flex;
    }

    @media (max-width: 576px) {
      .toggle--title {
        padding: 0 10px;
      }

      .toggle--switch {
        width: 100%;
      }
    }

    .section-company-milestones--content {
      max-width: 920px;
      padding: 0;
      margin: 100px auto 0;

      .section-company-milestones--timeline {
        .section-company-milestones--item {
          display: flex;
          align-items: start;

          .section-company-milestones--item-icon {
            height: 32px;
            display: flex;

            hr {
              width: 27px;
              margin: 10px 10px 10px 8px;
              border-style: dashed;
              border-width: 1px;
              border-color: #cfd8dc;
            }

            .st-icon-wrapper {
              width: 32px;
              height: 32px;
              min-width: 32px;
              margin-top: -6px;
              margin-right: 13px;

              img {
              }
            }
          }

          .section-company-milestones--item-text {
            .section-company-milestones--item-date {
              font-weight: bold;
              font-size: 20px;
              line-height: 120%;
              letter-spacing: -0.01em;
              color: var(--normal-description-color);
              margin: 0;
            }

            .section-company-milestones--item-description {
              font-weight: 500;
              font-size: 16px;
              line-height: 150%;
              color: var(--normal-description-color);
              margin: 10px 0 0;
            }
          }
        }

        .ant-timeline-item-right {
          .section-company-milestones--item {
            flex-direction: row-reverse;

            .section-company-milestones--item-icon {
              flex-direction: row-reverse;

              .st-icon-wrapper {
                margin-left: 13px;
                margin-right: 0;

                img {
                }
              }
            }
          }
        }
      }

      .section-company-milestones--next-button {
        font-weight: bold;
        font-size: 20px;
        line-height: 120%;
        text-align: center;
        letter-spacing: -0.01em;
        color: var(--normal-description-color);
        cursor: pointer;
      }
    }
  }

  @media (max-width: 991px) {
  }

  @media (max-width: 768px) {
    .section-company-milestones--container {
      padding: 48px 28px;

      .section-company-milestones--title {
        font-size: 29px;
        letter-spacing: -0.03em;
        margin-bottom: 25px;
      }

      .section-company-milestones--content {
        max-width: 606px;
        margin-top: 65px;
        padding: 0;

        .section-company-milestones--timeline {
          .section-company-milestones--item {
            .section-company-milestones--item-text {
              .section-company-milestones--item-date {
                font-size: 18px;
              }

              .section-company-milestones--item-description {
                font-size: 16px;
                margin-top: 8px;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
  }

  .ant-timeline {
    width: 100%;

    .ant-timeline-item-tail {
      border-left: 1px solid #003954;
    }

    .ant-timeline-item-head {
      background: #009de6;
      border: 2px solid #fff;
      width: 16px;
      height: 16px;
      margin-left: -7px !important;
      margin-top: -3px;
    }
  }

  @media (max-width: 576px) {
    .ant-timeline {
      .ant-timeline-item-head {
        margin-left: -3px !important;
      }
    }
  }
`;

export const SearchInputField = styled(Input)`
  height: 62px;
  width: 295px;
  border-radius: 0px !important;
  font-family: Sofia Pro;
  font-size: 20px !important;
  letter-spacing: 1.1px;
`;
